import { Component, OnInit, Input } from '@angular/core';
import { Container } from '../container-view/models/container';
import { ContainerItem } from '../container-view/models/container-item';
import { ContainerUtility } from '../utils/container-utility';
import { MaterialType } from '../carrier/carrier-enum';
import { ContainerType } from '../container-view/models/container-type-enum';
import { Material } from '../container-view/models/material';
import { ReactionSet } from '../container-view/models/reaction-set';

@Component({
  selector: 'app-container-cell-view',
  templateUrl: './container-cell-view.component.html',
  styleUrls: ['./container-cell-view.component.css']
})
export class ContainerCellViewComponent implements OnInit {

  @Input() selectedContainer: Container;
  @Input() i: number;
  @Input() j: number;
  @Input() hasToggle: boolean;
  @Input() showChemical: boolean;
  @Input() showPrimer: boolean;
  @Input() isCarrier: boolean;

  containerUtil: ContainerUtility = new ContainerUtility();
  carrierState: string;

  constructor() { }

  ngOnInit() {
    this.carrierState = "WIP";
  }
  getCarrierItemBarcode(i: number, j: number, selectedContainer: Container): string {
    return this.containerUtil.getCarrierItemBarcode(i, j, selectedContainer, this.isCarrier);
  }

  concatBarcodeAndError(i: number, j: number, selectedContainer: Container): string {
    let barcode: string = this.containerUtil.getCarrierItemBarcode(i, j, selectedContainer, this.isCarrier);
    let error: string =  this.getErrorTooltip(this.getCarrierItem(i,j,selectedContainer));
    return barcode + " " + error;
  }

  //Only for carrier, not for reaction Plate
  getStateAsString(selectedContainer: Container): string {
    return this.containerUtil.getStateAsString(selectedContainer);
  }

  getCarrierItemForIndex(selectedContainer: Container, i: number, j: number): ContainerItem {
    return this.containerUtil.getCarrierItemForIndex(selectedContainer, i, j);
  }

  getCarrierItem(i: number, j: number, item: Container) {
    let selectedContainer: Container = item;
    if (selectedContainer === null) {
      return null;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedContainer, i, j);

    if (currentItem !== null) {
      return currentItem;
    }
    return null;
  }


  isCarrierItemValid(i: number, j: number, item: Container): boolean {
    let selectedCarrier: Container = item;
    if (selectedCarrier === null) {
      return null;
    }
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    //Check for duplicates
    var isBarcodeDuplicate = currentItem !== null ? currentItem.hasDuplicate : false;

    //check for errors at thecarrierItem Level
    let isBarcodeValid = false
    if (currentItem !== undefined && currentItem != null &&
      currentItem.containerItemError !== undefined && currentItem.containerItemError != null) {
      isBarcodeValid = true
    }
    return isBarcodeDuplicate || isBarcodeValid;
  }

 

  /**
   * Checks availability of QC type in the GRID cell
   */
  isQcType(i: number, j: number, item: Container): boolean {

    if (item == null) return false;

    let selectedCarrier: Container = item;
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);
    if (currentItem == null) return false;

    if (item.containerType == ContainerType.CARRIER && currentItem.containerItemAware != null) {
      let material = currentItem.containerItemAware as Material;
      if (material != undefined && material != null && material.type == MaterialType.QCSample) {
        return true;
      }
    } else if (item.containerType == ContainerType.REACTIONPLATE && currentItem.containerItemAware != null) {
      let reactionSet = currentItem.containerItemAware as ReactionSet;
      if (reactionSet.reactionSetItems != undefined && reactionSet.reactionSetItems != null) {

        for (let material of reactionSet.reactionSetItems) {
          if (material != null && material.type == MaterialType.QCSample) {
            return true;
          }
        }
      }
    }
    return false;
  }



  /**
   * Extract Error, Qcsample information from containeritem
   * TODO Correct the logic for Reaction Plate with multiple material
   * @param carrierItem 
   */
  getErrorTooltip(carrierItem: ContainerItem) {

    let tooltip: string = ""
    if (carrierItem != null && carrierItem.hasDuplicate)
      tooltip = "Duplicate Barcode";
    if (carrierItem !== undefined && carrierItem != null && carrierItem.containerItemError !== undefined && carrierItem.containerItemError != null
      && carrierItem.containerItemError.message !== undefined && carrierItem.containerItemError.message != null) {
      if (tooltip.length > 0) {
        tooltip = tooltip + ", " + carrierItem.containerItemError.message;
      } else {
        tooltip = tooltip + carrierItem.containerItemError.message;
      }
    }
    // Find qctype for QCSample type, show it is QC tooltip
    if (carrierItem !== undefined && carrierItem != null) {
      if (carrierItem.containerItemAware instanceof Material) {
        let material = carrierItem.containerItemAware;
        if (material != undefined && material != null) {
          if (material.type == MaterialType.QCSample) {
            let qcType = carrierItem.qcType;
            tooltip = tooltip + "\n" + "QCSAMPLE:" + qcType;
          }
          if (material.type == MaterialType.Chemical && this.showChemical) {
            tooltip += "\nChemical: " + material.barcode;
          }
          if (material.type == MaterialType.Primer && this.showPrimer) {
            tooltip += "\nPrimer: " + material.barcode;
          }

        }
      }
      else if (carrierItem.containerItemAware instanceof ReactionSet) {
        let reactionSet = carrierItem.containerItemAware;
        if (reactionSet.reactionSetItems != undefined && reactionSet.reactionSetItems != null) {
          for (let material of reactionSet.reactionSetItems) {
            if (material != null && material.type == MaterialType.QCSample) {
              let qcType = carrierItem.qcType;
              tooltip = tooltip + "\n" + "QCSAMPLE:" + qcType;
            }
            if (material.type == MaterialType.Chemical && this.showChemical) {
              tooltip += "\nChemical: " + material.barcode;
            }
            if (material.type == MaterialType.Primer && this.showPrimer) {
              tooltip += "\nPrimer: " + material.barcode;
            }
          }
        }
      }
    }
    return tooltip;
  }

  // getTooltipForReactionPlate(containerItem: ContainerItem) {
  //   let tooltip: string = ""
  //   if (containerItem == null) {
  //     return "";
  //   }
  //   containerItem.materials.forEach(material => {
  //     if (material.type == MaterialType.Chemical && this.showChemical) {
  //       tooltip += "Chemical: " + material.barcode;
  //     }
  //     if (material.type == MaterialType.Primer && this.showPrimer) {
  //       tooltip += "Primer: " + material.barcode;
  //     }
  //   });
  //   return tooltip;
  // }


  // onEnter(event, i, j, item: Carrier) {
  //   if (this.isVertical) {
  //     i = i + 1;
  //     if (i == 8) {
  //       i = 0;
  //       j = j + 1;
  //     }
  //     if (j < 12) {
  //       document.getElementById('textBox-' + item._id + i + j).focus();
  //     }
  //   } else {
  //     j = j + 1;
  //     if (j == 12) {
  //       j = 0;
  //       i = i + 1;
  //     }
  //     if (i < 8) {
  //       document.getElementById('textBox-' + item._id + i + j).focus();
  //     }
  //   }
  // }

  // private textareaChanged(newbarcode: string, i: number, j: number) {

  //   if (this.selectedCarrier.containerItems === null || isUndefined(this.selectedCarrier.containerItems)) {
  //     this.selectedCarrier.containerItems = new Array<ContainerItem>();
  //   }

  //   if (this.selectedCarrier === null) {
  //     return;
  //   }
  //   let currentItem: ContainerItem = this.getCarrierItemForIndex(this.selectedCarrier, i, j);
  //   if (this.getStateAsString(this.selectedCarrier) == this.carrierState)
  //     this.selectedCarrier.isDirty = true;
  //   else
  //     this.selectedCarrier.isDirty = false;

  //   if (currentItem != null) {
  //     if (newbarcode == "") {
  //       var index = this.selectedCarrier.containerItems.indexOf(currentItem);
  //       this.selectedCarrier.containerItems.splice(index, 1);

  //       if (this.bbApiError != null && this.bbApiError.errors != null) {
  //         this.bbApiError.errors.forEach(element => {
  //           if (currentItem.barcode == element.code) {
  //             var index = this.bbApiError.errors.indexOf(element);
  //             this.bbApiError.errors.splice(index, 1);
  //           }
  //         });
  //       }

  //     }
  //     else
  //       currentItem.barcode = newbarcode;
  //   }
  //   else {
  //     let newCarrierItem: ContainerItem = new ContainerItem(newbarcode, 0, j + 1, i + 1, false, null);
  //     this.selectedCarrier.containerItems.push(newCarrierItem);
  //   }

  //   this.carriers.forEach(element => {
  //     if (element.barcode == this.selectedCarrier.barcode) {
  //       var index = this.carriers.indexOf(element);
  //       this.carriers[index].containerItems = this.selectedCarrier.containerItems;
  //       this.carriers[index].isDirty = this.selectedCarrier.isDirty;
  //   }
  // });
  //   this.checkForDuplicates();
  // }

  // private checkForDuplicates() {

  //   if (this.selectedCarrier === undefined || this.selectedCarrier === null) {
  //     return;
  //   }
  //   let carrierItemsOfSelectedCarrier: Array<ContainerItem> = this.selectedCarrier.containerItems;


  //   if (carrierItemsOfSelectedCarrier === undefined || carrierItemsOfSelectedCarrier === null || carrierItemsOfSelectedCarrier.length === 0) {
  //     return;
  //   }
  //   let barcodeMap: number[] = [];
  //   let count: number = 0;
  //   // collect amount per barcode
  //   carrierItemsOfSelectedCarrier.forEach(
  //     element => {
  //       let barcodeAmount: number = barcodeMap[element.barcode];
  //       if (barcodeAmount !== undefined && barcodeAmount !== null) {
  //         barcodeMap[element.barcode] = barcodeAmount + 1;
  //         if (barcodeAmount == 1) {
  //           count++;
  //         }
  //       }
  //       else {
  //         barcodeMap[element.barcode] = 1;
  //       }
  //     });
  //   this.selectedCarrier.errorCount = count;
  //   // mark the duplicates
  //   carrierItemsOfSelectedCarrier.forEach(
  //     element => {
  //       let barcodeAmount: number = barcodeMap[element.barcode];
  //       element.hasDuplicate = barcodeAmount > 1;
  //     });

  // }

}
